<div class="modelContainer">
  <div class="">
    <button (click)="onCancelClick(false)" type="button" class="close cancelBtn" aria-label="Close" mat-dialog-close>
      Close
    </button>
  </div>
  <div class="modelTitle heading2 alignCenter">
    <span *ngIf="data.displayType=='add'">Create Component</span>
    <span *ngIf="data.displayType=='view'">View Component</span>
    <span *ngIf="data.displayType=='edit'">Edit Component</span>
  </div>
  <div class="modelBody regularText">
    <form [formGroup]="componentDetailForm">
      <div *ngIf="isLoading" class="svg-loader"></div>
      <div class="form-group row">
        <div class="col-9"></div>
        <mat-checkbox *ngIf="!hideCheckBox" formControlName="componentTargetConfiguration">
          <span class="font-color-white">Component Target Configuration</span>
        </mat-checkbox>
      </div>
      <div class="form-group row mt-3">
        <label for="tenantId" class="col-3 mandatory-field no-padding"><strong>Tenant Name</strong></label>
        <div class="col-3 zero-padding">
          <select id="tenantId" class="form-control select-btn" required formControlName="tenantId">
            <option value="" disabled selected>Select Tenant Name</option>
            <option *ngFor="let element of tenantList" [ngValue]="element.tenantId">{{element.tenantName}}</option>
          </select>
        </div>
        <label for="targetTypeId" *ngIf="displayTargetData()" class="col-3 mandatory-field no-padding plusbtnmargin">
          <strong>Datasoure Type</strong>
        </label>
        <div *ngIf="displayTargetData()" class="col-3 zero-padding">
          <select id="targetTypeId" class="form-control select-btn" required formControlName="targetTypeId">
            <option value="" disabled selected>Select Datasoure Type</option>
            <option *ngFor="let element of dataSourceTypesList" [ngValue]="element.datasourceTypeId">{{element.datasourceTypeName}}</option>
          </select>
        </div>
      </div>
      <div class="form-group row mt-3">
        <label for="componentId" class="col-3 mandatory-field no-padding"><strong>Component Name</strong></label>
        <div class="col-3 zero-padding">
          <select id="componentId" (change)="changeComponent($event)" class="form-control select-btn" required formControlName="masterComponentId">
            <option value="" disabled selected>Select Component Name</option>
            <option *ngFor="let element of masterComponentList" [ngValue]="element.componentId">
              {{element.componentName}}
            </option>
          </select>
        </div>
        <label for="targetTableName" *ngIf="displayTargetData()" class="col-3 mandatory-field no-padding plusbtnmargin">
          <strong>
            Target Table Name
          </strong>
        </label>
        <div *ngIf="displayTargetData()" class="col-3 zero-padding">
          <input type="text" formControlName="targetTableName" class="form-control" id="targetTableName" required />
        </div>
      </div>
      <div class="form-group row mt-3">
        <label for="componentDbConnStr" matTooltip="Component DB ADO connection secret name"
               class="col-3 mandatory-field no-padding"><strong>ADO Secret Name...</strong></label>
        <div class="col-3 zero-padding" >
          <input type="text" formControlName="componentDbConnStr" class="form-control" id="componentDbConnStr"
                 required />     
        </div>
        <label for="targetDbConnStr" matTooltip="Target DB ADO connection secret name" *ngIf="displayTargetData() && componentDetailForm.get('targetTypeId').value == 1"
               class="col-3 mandatory-field no-padding plusbtnmargin "><strong>ADO Secret Name...</strong></label>
        <div *ngIf="displayTargetData() && componentDetailForm.get('targetTypeId').value == 1" class="col-3 zero-padding">
          <input type="text" formControlName="targetDbConnStr" class="form-control" id="targetDbConnStr" required />
        </div>
        <label for="cosmosDbName" matTooltip="Target Cosmos DB Name"
               *ngIf="displayTargetData() && componentDetailForm.get('targetTypeId').value == 2" class="col-3 mandatory-field no-padding plusbtnmargin">
          <strong>
            Cosmos DB Name...
          </strong>
        </label>
        <div *ngIf="displayTargetData() && componentDetailForm.get('targetTypeId').value == 2" class="col-3 zero-padding">
          <input type="text" formControlName="cosmosDbName" class="form-control"
                 id="cosmosDbName" required />
        </div>
      </div>
      <div class="form-group row mt-3">
        <label for="componentDbConnStrValue" matTooltip="Component DB ADO connection secret value"
               class="col-3 mandatory-field no-padding"><strong>ADO Secret Value...</strong></label>
        <div class="col-3 zero-padding">
          <input type="text" formControlName="componentDbConnStrValue" class="form-control" id="componentDbConnStrValue"
                 required />
        </div>
        <label for="targetDbConnStrValue" matTooltip="Target DB ADO connection secret value" *ngIf="displayTargetData() && componentDetailForm.get('targetTypeId').value == 1"
               class="col-3 mandatory-field no-padding plusbtnmargin"><strong>ADO Secret Value...</strong></label>
        <div *ngIf="displayTargetData() && componentDetailForm.get('targetTypeId').value == 1" class="col-3 zero-padding">
          <input type="text" formControlName="targetDbConnStrValue" class="form-control" id="targetDbConnStrValue"
                 required />
        </div>
        <label for="cosmosDbKey" matTooltip="Target Cosmos Api Key Secret" *ngIf="displayTargetData() && componentDetailForm.get('targetTypeId').value == 2"
               class="col-3 mandatory-field no-padding plusbtnmargin "><strong>Cosmos Api Key Secret </strong></label>
        <div *ngIf="displayTargetData() && componentDetailForm.get('targetTypeId').value == 2" class="col-3 zero-padding">
          <input type="text" formControlName="cosmosDbKey" class="form-control" id="cosmosDbKey" required />
        </div>
      </div>
      <div class="form-group row mt-3">
        <label for="componentDbOdbcConnStr" matTooltip="Component DB ODBC connection secret name"
               class="col-3 mandatory-field no-padding"><strong>ODBC Secret Name...</strong></label>
        <div class="col-3 zero-padding">
          <input type="text" formControlName="componentDbOdbcConnStr" class="form-control" id="componentDbOdbcConnStr"
                 required />
        </div>
        <label for="targetDbOdbcConnStr" matTooltip="Target DB ODBC connection secret name" *ngIf="displayTargetData() && componentDetailForm.get('targetTypeId').value == 1"
               class="col-3 mandatory-field no-padding plusbtnmargin"><strong>ODBC Secret Name...</strong></label>
        <div *ngIf="displayTargetData() && componentDetailForm.get('targetTypeId').value == 1" class="col-3 zero-padding">
          <input type="text" formControlName="targetDbOdbcConnStr" class="form-control" id="targetDbOdbcConnStr"
                 required />
        </div>
        <label for="cosmosDbKeyValue" matTooltip="Target Cosmos Api Key Secret Value" *ngIf="displayTargetData() && componentDetailForm.get('targetTypeId').value == 2"
               class="col-3 mandatory-field no-padding plusbtnmargin"><strong>Cosmos Api Key Secret Value</strong></label>
        <div *ngIf="displayTargetData() && componentDetailForm.get('targetTypeId').value == 2" class="col-3 zero-padding">
          <input type="text" formControlName="cosmosDbKeyValue" class="form-control" id="cosmosDbKeyValue"
                 required />
        </div>
      </div>
      <div class="form-group row mt-3">
        <label for="componentDbOdbcConnStrValue" matTooltip="Component DB ODBC connection secret value"
               class="col-3 mandatory-field no-padding"><strong>ODBC Secret Value...</strong></label>
        <div class="col-3 zero-padding">
          <input type="text" formControlName="componentDbOdbcConnStrValue" class="form-control"
                 id="componentDbOdbcConnStrValue" required />
        </div>
        <label for="targetDbOdbcConnStrValue" matTooltip="Target DB ODBC connection secret value"
               *ngIf="displayTargetData() && componentDetailForm.get('targetTypeId').value == 1" class="col-3 mandatory-field no-padding plusbtnmargin">
          <strong>ODBC Secret Value...</strong>
        </label>
        <div *ngIf="displayTargetData() && componentDetailForm.get('targetTypeId').value == 1" class="col-3 zero-padding">
          <input type="text" formControlName="targetDbOdbcConnStrValue" class="form-control"
                 id="targetDbOdbcConnStrValue" required />
        </div>
        <label for="cosmosDbApiUrl" matTooltip="Target Cosmos API URL Secret" *ngIf="displayTargetData() && componentDetailForm.get('targetTypeId').value == 2"
               class="col-3 mandatory-field no-padding plusbtnmargin"><strong>Cosmos API URL Secret</strong></label>
        <div *ngIf="displayTargetData() && componentDetailForm.get('targetTypeId').value == 2" class="col-3 zero-padding">
          <input type="text" formControlName="cosmosDbApiUrl" class="form-control" id="cosmosDbApiUrl"
                 required />
        </div>
      </div>
      <div class="form-group row mt-3">
        <div class="col-6"></div>
        <label for="cosmosDbApiUrlValue" matTooltip="Target Cosmos API URL Secret Value"
               *ngIf="displayTargetData() && componentDetailForm.get('targetTypeId').value == 2" class="col-3 mandatory-field no-padding plusbtnmargin">
          <strong>Cosmos API URL Secret Value</strong>
        </label>
        <div *ngIf="displayTargetData() && componentDetailForm.get('targetTypeId').value == 2" class="col-3 zero-padding">
          <input type="text" formControlName="cosmosDbApiUrlValue" class="form-control"
                 id="cosmosDbApiUrlValue" required />
        </div>

      </div>
      <div class="d-flex alignCenter">
        <button id="createBtn" type="submit" *ngIf="data.displayType != 'view'"
          class="actionBtn primaryBtn mt-2" (click)="saveComponent()" [disabled]="disableSave()">
          Save
        </button>
      </div>
    </form>
  </div>
</div>
